<template>
  <div>
    <px-view-header title="Importar cotação" title-class="font-weight-bold"
                    :breadcrumbs="breadcrumbs">
      <template v-slot:before>
        <v-btn class="mb-4 mr-1" icon x-large color="primary" @click="onClickBack">
          <v-icon>
            mdi-arrow-left
          </v-icon>
        </v-btn>
      </template>
    </px-view-header>

    <div v-if="loadingForm">
      <px-circular-loading/>
    </div>

    <v-stepper class="elevation-1 rounded-card" v-if="!loadingForm" v-model="currentStep" vertical>

      <v-stepper-step :complete="currentStep > 1" step="1">
        Arquivo
      </v-stepper-step>
      <v-stepper-content step="1">
        <px-importar-cotacao-arquivo @next="onNextArquivo" />
      </v-stepper-content>

      <v-stepper-step :complete="currentStep > 2" step="2">
        Dados básicos
      </v-stepper-step>
      <v-stepper-content step="2">
        <px-cadastro-cotacao-dados-basicos :cotacao="cotacao"
                                           @ready="next"
                                           @cancel="onClickCancelar"/>
      </v-stepper-content>

      <v-stepper-step :complete="currentStep > 3" step="3">Produtos</v-stepper-step>
      <v-stepper-content step="3">
        <px-cadastro-cotacao-produtos-table v-if="currentStep === 3"
                                            :cotacao="cotacao"
                                            @next="next"
                                            @previous="previous"
                                            @resetfornecedor="resetFornecedor"/>
      </v-stepper-content>

      <v-stepper-step :complete="currentStep > 4" step="4">Fornecedores</v-stepper-step>
      <v-stepper-content step="4">
        <px-cadastro-cotacao-fornecedores v-if="currentStep === 4"
                                          :cotacao="cotacao"
                                          @resetfornecedor="resetFornecedor"/>
        <v-btn color="primary" class="rounded-tag-small normal-btn-text"
               :loading="loading" @click="enviarCotacao"
               :disabled="!cotacao.fornecedores.length">
          Enviar
        </v-btn>
        <v-btn text @click="previous" :disabled="loading" class="normal-btn-text">
          Voltar
        </v-btn>
      </v-stepper-content>
    </v-stepper>
  </div>
</template>

<script>
import { FinalidadeCompra } from 'px-business-components';
import ImportarCotacaoArquivo from '@/modules/cotacao/importacao/ImportarCotacaoArquivo.vue';
import pxCadastroCotacaoDadosBasicos
  from '@/modules/cotacao/cadastro/CadastroCotacaoDadosBasicos.vue';
import pxCadastroCotacaoProdutosTable
  from '@/modules/cotacao/cadastro/produtos/CadastroCotacaoProdutosTable.vue';
import pxCadastroCotacaoFornecedores
  from '@/modules/cotacao/cadastro/fornecedores/CadastroCotacaoFornecedores.vue';
import CotacaoService from '@/modules/cotacao/cotacao-service';
import CompradorService from '@/api/comprador-service';

export default {
  data() {
    return {
      breadcrumbs: [
        { text: 'Gestão de compras' },
        {
          text: 'Cotações',
          to: '/cotacoes',
        },
        { text: 'Importar cotação' },
      ],
      currentStep: 1,
      loadingForm: false,
      loading: false,
      cotacao: {
        comprador: null,
        compradorEntrega: null,
        tipoFrete: null,
        prazoEntrega: null,
        validade: null,
        finalidadeCompra: FinalidadeCompra.keys.USO_CONSUMO.key,
        formaPagamento: null,
        prazoPagamento: null,
        observacao: null,
        tipoCotacao: 'COTACAO_ABERTA',
        situacao: 'ABERTA',
        produtos: [],
        fornecedores: [],
      },
    };
  },
  methods: {
    onClickBack() {
      this.$router.push({ name: 'main.cotacoes' });
    },
    onNextArquivo(arquivoResult) {
      this.cotacao.produtos = arquivoResult.produtos.map(produto => ({
        especificacaoProduto: produto.especificacaoProduto,
        marca: produto.marca,
        produto: produto.produto,
        quantidade: produto.quantidade,
        unidadeMedida: produto.unidadeMedida,
        arquivos: produto.produto.arquivos || [],
        $$hasFileLoading: false,
      }));

      this.next();
    },
    next() {
      this.currentStep = this.currentStep + 1;
    },
    previous() {
      this.currentStep = this.currentStep - 1;
    },
    onClickCancelar() {
      this.$router.push({ name: 'main.cotacoes' });
    },
    buildCotacaoBody() {
      return { ...this.cotacao };
    },
    resetFornecedor() {
      this.cotacao.fornecedores = [];
    },
    enviarCotacao() {
      this.loading = true;
      CotacaoService.save(this.buildCotacaoBody())
        .then(() => {
          this.$toast('Cotação enviada com sucesso', { color: 'success' });
          this.$router.push({ name: 'main.cotacoes' });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getCompradorFaturamentoDefault() {
      return CompradorService.getDefaultFaturamento()
        .then((response) => {
          this.cotacao.comprador = response.data;
        });
    },
    getCompradorEntregaDefault() {
      return CompradorService.getDefaultEntrega()
        .then((response) => {
          this.cotacao.compradorEntrega = response.data;
        });
    },
  },
  created() {
    this.loadingForm = true;
    Promise.all([
      this.getCompradorEntregaDefault(),
      this.getCompradorFaturamentoDefault(),
    ])
      .finally(() => {
        this.loadingForm = false;
      });
  },
  components: {
    pxCadastroCotacaoFornecedores,
    pxCadastroCotacaoProdutosTable,
    pxCadastroCotacaoDadosBasicos,
    pxImportarCotacaoArquivo: ImportarCotacaoArquivo,
  },
};
</script>
